import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { EmpresaDGI } from './empresas-dgi.model';

export const entityEmpresaDGIAdapter: EntityAdapter<EmpresaDGI> =
  createEntityAdapter<EmpresaDGI>({
    selectId: (model) => model.RUT,
    sortComparer: (a: EmpresaDGI, b: EmpresaDGI): number => -1
  });

export interface EntityEmpresaDGIState extends EntityState<EmpresaDGI> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityEmpresaDGIState =
  entityEmpresaDGIAdapter.getInitialState({
    isLoading: false,
    error: null
  });

